import type { AcademyContent } from "@/components/ui/arbi-academy-modal";

export const PROJECTS_ACADEMY_CONTENT: AcademyContent = {
  type: "projects",
  typeLabel: "Projects",
  title: "The Basics of Projects",
  description:
    "Discover how to create and organize projects in Arbi. Learn how to set access levels, add collaborators, assign cover images, and use projects to group related job requisitions for a cleaner, more structured hiring workflow.",
  duration: "3 mins",
  videoUrl: "https://www.youtube.com/watch?v=setu9Ir1miY",
  thumbnailUrl: "/assets/academy/projects-thumbnail.png",
  accentColor: "#C9BFFF",
  typeColor: "#C9BFFF",
  docsUrl: "https://docs.neuroscale.ai/core/projects",
};
